import "devextreme/dist/css/dx.light.css"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { useSelector } from "react-redux"
import { Routes, Route } from "react-router-dom"

// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes"

// Import all middleware
import Authmiddleware from "./routes/route"

// layouts Format 
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import "./App.css"
import "./assets/css/RolesResponse/Roles.css"

import Authenticate from "routes/Authenticate"
import NotFound from "pages/WrongUrl/NotFound"

import "devextreme/dist/css/dx.light.css"
import FloatingBtn from "pages/Reports/FloatingBtn"
import { checkPermissionsByModule } from "utils/common-helpers"
import NotificationComponent from "utils/NotificationComponent"
import secureLocalStorage from "react-secure-storage"
import TimerClockHr from "pages/HumanResources/TimerClockHr"
import axios from "axios"
import configure from "configure"
import Timesheet from "pages/HumanResources/Timesheet"
// import Help from "pages/HumanResources/Help/Help"

const App = () => {
  const [tempWfh, setTempWfh] = useState(false)


  const Layout = HorizontalLayout
  const roles = useSelector(state => state?.Roles?.apiData)
  const permission = checkPermissionsByModule(roles, 96, 3)
  const isWft = secureLocalStorage.getItem("isWfh") == 1

  const getWFHPermission = async () => {
    try {
      const response = await axios.get(
        `${configure.nodeApi}/applyWFH/checkWFH/${localStorage.getItem(
          "auth_id"
        )}`
      )
      console.log("response: ", response)
      if (response?.data?.permission) {
        console.log("data: ", response?.data?.permission)
        setTempWfh(true)
      }
    } catch (error) {
      console.log("error: ", error.message)
    }
  }
  useEffect(() => {
    getWFHPermission()
  }, [])

  useEffect(() => {
    if (localStorage.getItem("auth_id")) {
      (async () => {
        const response = await axios.get(
          `${configure.nodeApi
          }/allUsers/getLoggedInUserDetails/${localStorage.getItem("auth_id")}`
        )

        secureLocalStorage.setItem("auth_email", response.data.data.email)
        secureLocalStorage.setItem("auth_avt", response.data.data.avatar)
        secureLocalStorage.setItem("auth_name", response.data.data.name)
        secureLocalStorage.setItem("auth_role", response.data.data.roleid)
        localStorage.setItem("auth_email", response.data.data.email)
        localStorage.setItem("auth_avt", response.data.data.avatar)
        localStorage.setItem("auth_name", response.data.data.name)
        localStorage.setItem("auth_role", response.data.data.roleid)
      })()
    }
  }, [])

  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => {
          return (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <>
                    {route.module_id != undefined ? (
                      <Authenticate
                        module={route.module_id}
                        type={route.type}
                      >
                        <Layout>{route.component}</Layout>
                      </Authenticate>
                    ) : (
                      <Layout>{route.component}</Layout>
                    )}

                    {/* <Help /> */}
                    {/* <Timesheet /> */}

                  </>
                </Authmiddleware>
              }
              key={idx}
              exact={true}
            />
          )
        })}
        <Route path="*" element={<NotFound />} />
      </Routes>
      {permission ? <FloatingBtn /> : null}

      {/* {isWft || tempWfh ? <TimerClockHr /> : null} */}

      <NotificationComponent userId={localStorage.getItem("auth_id")} />
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
